import React, { useEffect, useState } from "react";
import { AddIcon, LoadingIcon } from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { AddCorporateCustomer } from "../../api/corporate-customers/createCorporateCustomer";
import useForm from "../../hooks/useForm";
import FormErrorsOutput from "../form/FormErrorsOutput";
import { useTranslation } from "react-i18next";
import StateSelect from "../form/StateSelect";
import CountrySelect from "../form/CountrySelect";

const CreateCorporateCustomer = ({ onCreate, onClose, ...props }) => {
  const { t } = useTranslation();

  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [corporateName, setCorporateName] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");

  const { loading, error, fieldErrors, handleSubmit } = useForm(onCreate);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(AddCorporateCustomer, {
      corporate_name: corporateName,
      address1,
      address2,
      city,
      state,
      postal_code: postalCode,
      country_code: country,
    });
  };

  useEffect(() => {
    if (corporateName) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [corporateName]);

  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <form method="post" onSubmit={handleFormSubmit}>
        <FormHeader
          title={t("Create Corporate Customer")}
          description={t(
            "Input accurate data entry to facilitate smooth corporate customer management."
          )}
          className="mb-5"
        ></FormHeader>

        <div className="row mb-5">
          <div className="col-xs-12">
            <FormSection title={t("Corporate Name")} required>
              <input
                type="text"
                name="corporate_name"
                id="corporate_name"
                maxLength="100"
                placeholder={t("Corporate customer name")}
                value={corporateName}
                onChange={(e) => setCorporateName(e.target.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-12">
            <FormSection title={t("Address Line 1")}>
              <input
                type="text"
                name="address1"
                id="address1"
                maxLength="200"
                placeholder={t("Street address")}
                value={address1}
                onChange={(e) => setAddress1(e.target.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-12">
            <FormSection title={t("Address Line 2")}>
              <input
                type="text"
                name="address2"
                id="address2"
                maxLength="200"
                placeholder={t("Apartment, suite, unit, building, floor, etc.")}
                value={address2}
                onChange={(e) => setAddress2(e.target.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-6">
            <FormSection title={t("City")}>
              <input
                type="text"
                name="city"
                id="city"
                maxLength="100"
                placeholder={t("City")}
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </FormSection>
          </div>
          <div className="col-xs-6">
            <FormSection title={t("State/Province")}>
              <StateSelect
                value={state}
                onChange={(option) => setState(option.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-6">
            <FormSection title={t("Postal Code")}>
              <input
                type="text"
                name="postal_code"
                id="postal_code"
                maxLength="20"
                placeholder={t("Postal/ZIP code")}
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </FormSection>
          </div>
          <div className="col-xs-6">
            <FormSection title={t("Country")}>
              <CountrySelect
                onlyCountry={"Canada"}
                value={country}
                onChange={(option) => setCountry(option.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="text-right">
          <button
            className={`btn btn-primary btn-medium ${
              loading ? "btn-loading" : ""
            }`}
            type="submit"
            name="submit"
            disabled={submitDisabled}
          >
            {loading ? <LoadingIcon /> : <AddIcon />}
            {t("Add")}
          </button>
        </div>
        <FormErrorsOutput error={error} fieldErrors={fieldErrors} />
      </form>
    </Popup>
  );
};

export default CreateCorporateCustomer;
